import React from 'react';
import { AlertCircle, CheckCircle2, Shield, Clock, FileText, Star, Lock, CreditCard, BookOpen, Scale, FileCheck, ArrowRight, HeartPulse, X } from 'lucide-react';
import { CountdownTimer } from '../components/CountdownTimer';
import { TestimonialCard } from '../components/TestimonialCard';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/57LM59N8DxX6wVhub68PLB/background_removalTUFIT0RiaTF3ZVEjMSM2Y2FmMjhhNTNhMzRiYzBiNTFlMTQ3ZGQxNmEyZTRmMCMxMDI0IyNUUkFOU0ZPUk1BVElPTl9SRVFVRVNU.png';
export function LandingPage() {
  const scrollToOferta = () => {
    document.getElementById('oferta-destacada')?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };
  return <div className="min-h-screen bg-[#07120e] text-emerald-50 font-sans selection:bg-emerald-500/30" data-id="element-35">
      {/* Hero Section */}
      <header className="relative overflow-hidden border-b border-emerald-900/50 pt-8 pb-10 px-4" data-id="element-36">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_rgba(16,185,129,0.18),_transparent_60%)] -z-10" data-id="element-37" />
        <div className="max-w-3xl mx-auto text-center" data-id="element-38">
          <div className="inline-flex items-center gap-2 bg-emerald-500/10 text-emerald-300 px-4 py-2 rounded-full font-bold text-sm mb-4 border border-emerald-500/30" data-id="element-39">
            <HeartPulse className="w-4 h-4" data-id="element-40" />
            RECLAMO MÉDICO URGENTE™
          </div>

          <h1 className="md:text-5xl font-black tracking-tight mb-3 text-white text-[30px]" data-id="element-41">
            Todo tu reclamo médico.
            <br data-id="element-42" />
            <span className="text-emerald-400" data-id="element-43">Listo. Desde hoy.</span>
          </h1>

          <p className="text-lg md:text-xl text-emerald-100/80 mb-2 max-w-2xl mx-auto font-medium leading-relaxed" data-id="element-44">
            El sistema N°1 para reclamar coberturas médicas en Argentina —{' '}
            <span className="font-bold text-white" data-id="element-45">
              Prepaga · Obra Social · PAMI
            </span>
          </p>

          {/* Imagen del producto centrada debajo del título */}
          <div className="relative flex justify-center items-center my-4" data-id="element-46">
            <div className="absolute inset-0 bg-emerald-400/25 blur-[100px] rounded-full -z-10" data-id="element-47" />
            <img src={PRODUCT_IMAGE} alt="Superkit del Reclamo Médico Urgente — 6 tomos, modelos y bonos" className="w-full max-w-sm drop-shadow-[0_25px_45px_rgba(0,0,0,0.55)]" data-id="element-48" />
          </div>

          <p className="text-emerald-200/70 mb-5 max-w-xl mx-auto text-[15px]" data-id="element-49">
            Modelos + checklists + escalada listos para usar. Sin abogado. Sin
            vueltas.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6" data-id="element-50">
            <button onClick={scrollToOferta} className="w-full sm:w-auto bg-emerald-500 hover:bg-emerald-400 text-emerald-950 text-xl font-bold py-4 px-8 rounded-xl shadow-lg shadow-emerald-500/25 transition-all transform hover:scale-105 flex items-center justify-center gap-2" data-id="element-51">
              QUIERO MI KIT AHORA
              <ArrowRight className="w-6 h-6" data-id="element-52" />
            </button>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6 text-sm font-medium text-emerald-200/70" data-id="element-53">
            <div className="flex items-center gap-2" data-id="element-54">
              <FileText className="w-5 h-5 text-emerald-400" data-id="element-55" /> 100% PDF
            </div>
            <div className="flex items-center gap-2" data-id="element-56">
              <Clock className="w-5 h-5 text-emerald-400" data-id="element-57" /> Acceso en 5 min
            </div>
            <div className="flex items-center gap-2" data-id="element-58">
              <span className="text-xl" data-id="element-59">🇦🇷</span> Exclusivo Argentina
            </div>
            <div className="flex items-center gap-2" data-id="element-60">
              <CheckCircle2 className="w-5 h-5 text-emerald-400" data-id="element-61" /> Todos los
              casos
            </div>
          </div>
        </div>
      </header>

      {/* Trust Bar */}
      <div className="bg-emerald-950/60 border-y border-emerald-900/50 text-emerald-200/80 py-6 px-4" data-id="element-62">
        <div className="max-w-5xl mx-auto flex flex-wrap justify-center gap-8 md:gap-16 text-sm font-medium" data-id="element-63">
          <div className="flex items-center gap-2" data-id="element-64">
            <Shield className="w-5 h-5 text-emerald-400" data-id="element-65" /> Garantía 7 días
          </div>
          <div className="flex items-center gap-2" data-id="element-66">
            <Lock className="w-5 h-5 text-emerald-400" data-id="element-67" /> Pago seguro
          </div>
          <div className="flex items-center gap-2" data-id="element-68">
            <CreditCard className="w-5 h-5 text-emerald-400" data-id="element-69" /> Mercado Pago
          </div>
        </div>
      </div>

      {/* Stats & Social Proof */}
      <section className="py-16 px-4" data-id="element-70">
        <div className="max-w-5xl mx-auto" data-id="element-71">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center mb-16 border-b border-emerald-900/50 pb-16" data-id="element-72">
            <div data-id="element-73">
              <div className="text-4xl font-black text-white mb-1" data-id="element-74">+1.200</div>
              <div className="text-sm text-emerald-300/70 font-medium" data-id="element-75">
                personas que reclamaron
              </div>
            </div>
            <div data-id="element-76">
              <div className="text-4xl font-black text-white mb-1" data-id="element-77">6</div>
              <div className="text-sm text-emerald-300/70 font-medium" data-id="element-78">
                Tomos listos
              </div>
            </div>
            <div data-id="element-79">
              <div className="text-4xl font-black text-white mb-1" data-id="element-80">6</div>
              <div className="text-sm text-emerald-300/70 font-medium" data-id="element-81">
                Bonos incluidos
              </div>
            </div>
            <div data-id="element-82">
              <div className="text-4xl font-black text-white mb-1 flex items-center justify-center gap-1" data-id="element-83">
                4.9/5 <Star className="w-6 h-6 fill-amber-400 text-amber-400" data-id="element-84" />
              </div>
              <div className="text-sm text-emerald-300/70 font-medium" data-id="element-85">
                calificación
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-86">
            <TestimonialCard initials="MG" quote="Envié el primer email un martes a las 10hs. El miércoles a las 16hs me llamaron para autorizar la cirugía. El modelo del Tomo 2 fue todo." name="María G." location="Buenos Aires" data-id="element-87" />
            <TestimonialCard initials="LP" quote="Llevaba 3 semanas peleando con la prepaga. Con el kit armé el expediente en una tarde y en 48 horas tenía la autorización del estudio." name="Laura P." location="Rosario" data-id="element-88" />
            <TestimonialCard initials="RM" quote="Mi mamá tiene 74 años y PAMI le negaba la medicación hace 2 meses. Con el kit y la denuncia en SSSalud lo resolvimos en 4 días." name="Roberto M." location="Córdoba" data-id="element-89" />
          </div>
        </div>
      </section>

      {/* Problem Agitation */}
      <section className="py-20 px-4 bg-emerald-950/30" data-id="element-90">
        <div className="max-w-3xl mx-auto" data-id="element-91">
          <h2 className="text-3xl md:text-4xl font-black text-center mb-8 text-white" data-id="element-92">
            ¿Cuántos días más vas a esperar sin cobertura?
          </h2>
          <p className="text-lg text-emerald-100/80 mb-10 text-center leading-relaxed" data-id="element-93">
            Tenés una urgencia médica. Sabés que te corresponde. Pero la prepaga
            no responde, la obra social dice que "está en auditoría" y PAMI
            tiene una fila que no termina.
            <br data-id="element-94" />
            <br data-id="element-95" />
            <strong className="text-rose-400" data-id="element-96">
              No es falta de derechos. Es falta de un sistema.
            </strong>
          </p>

          <div className="space-y-4 bg-emerald-950/40 p-8 rounded-2xl border border-emerald-800/40" data-id="element-97">
            {["Llamás todos los días al 0800 y siempre te dicen 'está en proceso'", "Enviaste papeles que 'faltan' tres veces y siempre falta algo diferente", 'No sabés si lo que te dijeron tiene algún valor legal o es solo una respuesta de pasillo', 'El médico te indicó algo urgente y la empresa te hace esperar como si fuera opcional', 'Buscaste en Google qué hacer y encontraste 40 respuestas distintas que se contradicen', 'Ya pasaron días, semanas, y el problema sigue exactamente igual que el primer día'].map((item, i) => <div key={i} className="flex gap-4 items-start" data-id="element-98">
                <div className="mt-1 bg-rose-500/15 border border-rose-500/30 p-1 rounded-full shrink-0" data-id="element-99">
                  <X className="w-4 h-4 text-rose-400" data-id="element-100" />
                </div>
                <p className="text-emerald-100/80 font-medium" data-id="element-101">{item}</p>
              </div>)}
          </div>

          <div className="mt-12 text-center" data-id="element-102">
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-103">
              ¿Y si hoy fuera el último día que pasás sin saber qué hacer?
            </h3>
          </div>
        </div>
      </section>

      {/* Product Reveal - 6 Tomos */}
      <section className="py-20 px-4" data-id="element-104">
        <div className="max-w-5xl mx-auto" data-id="element-105">
          <div className="text-center mb-16" data-id="element-106">
            <div className="inline-flex items-center gap-2 bg-emerald-500/10 text-emerald-300 px-4 py-2 rounded-full font-bold text-sm mb-4 border border-emerald-500/30" data-id="element-107">
              <BookOpen className="w-4 h-4" data-id="element-108" />
              SISTEMA PAE COMPLETO
            </div>
            <h2 className="text-3xl md:text-5xl font-black text-white mb-6" data-id="element-109">
              6 TOMOS COMPLETOS
            </h2>
            <p className="text-xl text-emerald-200/70" data-id="element-110">
              300+ páginas — Todo resuelto.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 mb-16" data-id="element-111">
            {[{
            icon: '📘',
            title: 'Tomo 1 — Primeros Pasos',
            desc: 'Diagnóstico del caso, checklists iniciales, cómo identificar la negativa y organizar todo en las primeras 24/72 horas.'
          }, {
            icon: '📗',
            title: 'Tomo 2 — Modelos Listos para Copiar',
            desc: 'Textos para obras sociales, prepagas, PAMI, medicación, cirugías, prótesis, discapacidad, reintegros y más.'
          }, {
            icon: '📙',
            title: 'Tomo 3 — Trámites Desde el Celular',
            desc: 'Cómo gestionar todo desde tu teléfono: email, WhatsApp, TAD, formularios web y seguimiento sin perder plazos.'
          }, {
            icon: '📕',
            title: 'Tomo 4 — El Expediente Blindado',
            desc: 'Cómo pedir la historia clínica, armar el legajo completo y construir un expediente que la empresa no pueda ignorar.'
          }, {
            icon: '📓',
            title: 'Tomo 5 — La Escalada Formal',
            desc: 'SSSalud, Defensoría, Defensa del Consumidor, carta documento, pronto despacho e intimaciones paso a paso.'
          }, {
            icon: '📔',
            title: 'Tomo 6 — Kit Final de Formularios',
            desc: 'Checklists, planillas de seguimiento, hojas de ruta, registro de vencimientos y packs de frases listas para usar.'
          }].map((tomo, i) => <div key={i} className="flex gap-4 p-6 bg-emerald-950/40 rounded-2xl border border-emerald-800/40 hover:border-emerald-500/50 transition-colors" data-id="element-112">
                <div className="text-4xl" data-id="element-113">{tomo.icon}</div>
                <div data-id="element-114">
                  <h3 className="font-bold text-lg text-white mb-2" data-id="element-115">
                    {tomo.title}
                  </h3>
                  <p className="text-emerald-100/70 text-sm leading-relaxed" data-id="element-116">
                    {tomo.desc}
                  </p>
                </div>
              </div>)}
          </div>

          <div className="bg-emerald-600 text-emerald-950 rounded-3xl p-8 md:p-12 shadow-xl shadow-emerald-900/40" data-id="element-117">
            <h3 className="text-2xl font-bold mb-8 text-center text-white" data-id="element-118">
              Cada tomo incluye:
            </h3>
            <div className="grid md:grid-cols-2 gap-y-4 gap-x-8" data-id="element-119">
              {['Modelos de reclamo listos para copiar y completar', 'Checklists de documentación por tipo de caso', 'Fundamento legal actualizado (PMO + Ley 26.682)', 'Scripts para llamadas telefónicas', 'Plan de seguimiento con plazos exactos', 'Errores más comunes y cómo evitarlos', 'Casos ejemplo resueltos paso a paso', '100% adaptado a la realidad argentina 2024'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-120">
                  <CheckCircle2 className="w-5 h-5 text-emerald-900 shrink-0" data-id="element-121" />
                  <span className="font-medium text-emerald-950" data-id="element-122">{item}</span>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* Bonuses */}
      <section className="py-20 px-4 bg-emerald-950/50 border-y border-emerald-900/50" data-id="element-123">
        <div className="max-w-5xl mx-auto" data-id="element-124">
          <div className="text-center mb-16" data-id="element-125">
            <h2 className="text-3xl md:text-5xl font-black mb-6 text-white" data-id="element-126">
              🎁 6 BONOS ESTRATÉGICOS
            </h2>
            <p className="text-xl text-emerald-200/70" data-id="element-127">SIEMPRE INCLUIDOS</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-128">
            {[{
            num: '01',
            title: "Kit 'Mi Caso en 15 Minutos'",
            desc: 'Organizá tu reclamo urgente en una sola sentada con claridad total.',
            val: '$8.000'
          }, {
            num: '02',
            title: "Checklist 'Expediente Imposible de Ignorar'",
            desc: 'Armá un expediente tan prolijo que la entidad no tenga excusas para patearte el caso.',
            val: '$10.000'
          }, {
            num: '03',
            title: "Guía 'Las 12 Frases que Hacen que te Respondan'",
            desc: 'Usá el lenguaje correcto para sonar firme, técnico y difícil de ignorar.',
            val: '$9.000'
          }, {
            num: '04',
            title: "Plan '48 Horas Sin Respuesta'",
            desc: 'Si nadie responde, este plan te dice exactamente qué hacer hora por hora.',
            val: '$8.000'
          }, {
            num: '05',
            title: "Mini Guía 'Cómo Pedir la Negativa por Escrito'",
            desc: "Convertí el 'no' verbal en evidencia real que podés usar para escalar.",
            val: '$9.000'
          }, {
            num: '06',
            title: "Agenda 'Seguimiento Sin Olvidos'",
            desc: 'Controlá cada contacto, cada plazo y cada respuesta sin perder el hilo.',
            val: '$9.000'
          }].map((bono, i) => <div key={i} className="bg-emerald-950/60 p-6 rounded-2xl border border-emerald-800/40 relative overflow-hidden group hover:border-emerald-500 transition-colors" data-id="element-129">
                <div className="absolute top-0 right-0 bg-emerald-500 text-emerald-950 font-black text-xs px-3 py-1 rounded-bl-lg z-10" data-id="element-130">
                  GRATIS
                </div>
                <div className="text-emerald-700/60 font-black text-4xl mb-4 group-hover:text-emerald-500 transition-colors" data-id="element-131">
                  {bono.num}
                </div>
                <h3 className="font-bold text-lg mb-2 text-emerald-300" data-id="element-132">
                  {bono.title}
                </h3>
                <p className="text-emerald-100/70 text-sm mb-4" data-id="element-133">{bono.desc}</p>
                <div className="text-xs text-emerald-400/50 line-through" data-id="element-134">
                  Valor: {bono.val}
                </div>
              </div>)}
          </div>

          <div className="mt-12 text-center bg-emerald-950/60 p-6 rounded-2xl border border-emerald-500/30 inline-block mx-auto w-full max-w-2xl" data-id="element-135">
            <p className="text-xl font-medium text-emerald-100" data-id="element-136">
              Valor total bonos{' '}
              <span className="line-through text-emerald-400/50" data-id="element-137">$53.000</span>{' '}
              →{' '}
              <span className="text-emerald-400 font-black" data-id="element-138">
                GRATIS con tu Kit
              </span>
            </p>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className="py-20 px-4" data-id="element-139">
        <div className="max-w-5xl mx-auto" data-id="element-140">
          <div className="text-center mb-12" data-id="element-141">
            <div className="relative inline-block mb-8" data-id="element-142">
              <div className="absolute inset-0 bg-emerald-400/20 blur-[80px] rounded-full -z-10" data-id="element-143" />
              <img src={PRODUCT_IMAGE} alt="Todo lo que recibís: Superkit del Reclamo Médico Urgente con sus 6 tomos y bonos" className="w-full max-w-md mx-auto drop-shadow-[0_20px_40px_rgba(0,0,0,0.5)]" data-id="element-144" />
            </div>

            <h2 className="text-3xl md:text-4xl font-black text-white mb-2" data-id="element-145">
              ELEGÍ TU KIT
            </h2>
            <p className="text-emerald-200/70 mb-6 max-w-md mx-auto" data-id="element-146">
              Acceso inmediato a todo el sistema en PDF, listo para descargar.
            </p>

            <div className="bg-emerald-950/40 p-6 rounded-2xl border border-rose-500/30 inline-block mx-auto mb-8" data-id="element-147">
              <p className="text-rose-400 font-bold mb-4 uppercase tracking-wider text-sm flex items-center justify-center gap-2" data-id="element-148">
                <Clock className="w-4 h-4" data-id="element-149" /> Precio de lanzamiento — Cierra en:
              </p>
              <CountdownTimer data-id="element-150" />
              <p className="text-sm text-emerald-200/70 mt-4 font-medium" data-id="element-151">
                ⚠️ Después sube $8.000 ARS. No vuelve.
              </p>

              <div className="mt-4 bg-emerald-900/50 rounded-full h-2 w-full overflow-hidden" data-id="element-152">
                <div className="bg-rose-500 h-full w-[68%]" data-id="element-153"></div>
              </div>
              <p className="text-xs text-emerald-200/60 mt-2 font-medium" data-id="element-154">
                🔴 68% de los cupos al precio de lanzamiento ya tomados
              </p>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-155">
            {/* Basic Kit */}
            <div className="bg-emerald-950/40 rounded-3xl p-8 border border-emerald-800/40 flex flex-col" data-id="element-156">
              <div className="text-4xl mb-4" data-id="element-157">📘</div>
              <h3 className="text-2xl font-black text-white mb-2" data-id="element-158">
                KIT RECLAMO MÉDICO URGENTE
              </h3>
              <p className="text-emerald-200/70 font-medium mb-6" data-id="element-159">
                6 Tomos + 6 Bonos
              </p>

              <div className="bg-emerald-950/60 p-4 rounded-xl mb-6 border border-emerald-800/40" data-id="element-160">
                <p className="text-sm text-emerald-100/80" data-id="element-161">
                  <span className="font-bold text-white" data-id="element-162">Ideal para:</span> Un
                  reclamo activo — Prepaga, Obra Social o PAMI
                </p>
              </div>

              <div className="mb-8" data-id="element-163">
                <span className="text-emerald-400/50 line-through text-xl font-medium" data-id="element-164">
                  $51.000
                </span>
                <div className="text-4xl font-black text-white" data-id="element-165">
                  $19.990{' '}
                  <span className="text-lg text-emerald-300/70 font-medium" data-id="element-166">
                    ARS
                  </span>
                </div>
              </div>

              <a href="https://www.mododigital.shop/cart/45990214303942:1" target="_blank" rel="noopener noreferrer" className="w-full bg-emerald-900 hover:bg-emerald-800 text-white font-bold py-4 px-6 rounded-xl transition-colors flex items-center justify-center gap-2 mt-auto border border-emerald-700/50" data-id="element-167">
                QUIERO MI KIT AHORA <ArrowRight className="w-5 h-5" data-id="element-168" />
              </a>
            </div>

            {/* Pro Kit */}
            <div id="oferta-destacada" className="bg-emerald-950/60 rounded-3xl p-8 border-2 border-emerald-500 shadow-2xl shadow-emerald-900/50 relative flex flex-col transform md:-translate-y-4 scroll-mt-24" data-id="element-169">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-emerald-500 text-emerald-950 px-4 py-1 rounded-full text-sm font-bold flex items-center gap-1 shadow-lg whitespace-nowrap" data-id="element-170">
                <Star className="w-4 h-4 fill-current" data-id="element-171" /> MÁS ELEGIDO
              </div>

              <div className="text-4xl mb-4" data-id="element-172">🏆</div>
              <h3 className="text-2xl font-black text-white mb-2" data-id="element-173">
                KIT COMPLETO + BIBLIA DEL AMPARO
              </h3>
              <p className="text-emerald-200/70 font-medium mb-6" data-id="element-174">
                6 Tomos + 6 Bonos + Manual Judicial Completo
              </p>

              <div className="bg-emerald-500/10 p-4 rounded-xl mb-6 border border-emerald-500/30" data-id="element-175">
                <p className="text-sm text-emerald-100" data-id="element-176">
                  <span className="font-bold text-emerald-300" data-id="element-177">
                    Ideal para:
                  </span>{' '}
                  Cuando la entidad sigue negando y necesitás llevar el caso a
                  la justicia
                </p>
              </div>

              <div className="mb-8" data-id="element-178">
                <span className="text-emerald-400/50 line-through text-xl font-medium" data-id="element-179">
                  $69.000
                </span>
                <div className="text-4xl font-black text-emerald-400" data-id="element-180">
                  $27.990{' '}
                  <span className="text-lg text-emerald-300/70 font-medium" data-id="element-181">
                    ARS
                  </span>
                </div>
              </div>

              <a href="https://www.mododigital.shop/cart/45990216597702:1" target="_blank" rel="noopener noreferrer" className="w-full bg-emerald-500 hover:bg-emerald-400 text-emerald-950 font-bold py-4 px-6 rounded-xl transition-all shadow-lg shadow-emerald-500/25 transform hover:scale-105 flex items-center justify-center gap-2 mt-auto" data-id="element-182">
                QUIERO EL KIT COMPLETO <ArrowRight className="w-5 h-5" data-id="element-183" />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Upsell Details */}
      <section className="py-20 px-4 border-t border-emerald-900/50" data-id="element-184">
        <div className="max-w-4xl mx-auto" data-id="element-185">
          <div className="text-center mb-12" data-id="element-186">
            <h2 className="text-3xl font-black text-white mb-4 flex items-center justify-center gap-3" data-id="element-187">
              <Scale className="w-8 h-8 text-emerald-400" data-id="element-188" />
              ¿QUÉ AGREGA LA "BIBLIA DEL AMPARO"?
            </h2>
          </div>

          <div className="overflow-x-auto mb-12 rounded-2xl border border-emerald-800/40" data-id="element-189">
            <table className="w-full text-left border-collapse" data-id="element-190">
              <thead data-id="element-191">
                <tr className="bg-emerald-950/60" data-id="element-192">
                  <th className="p-4 border-b border-emerald-800/40 font-bold text-white" data-id="element-193">
                    Situación
                  </th>
                  <th className="p-4 border-b border-emerald-800/40 font-bold text-rose-400 bg-rose-500/5 text-center" data-id="element-194">
                    ❌ Sin Biblia
                  </th>
                  <th className="p-4 border-b border-emerald-800/40 font-bold text-emerald-400 bg-emerald-500/5 text-center" data-id="element-195">
                    ✅ Con Biblia
                  </th>
                </tr>
              </thead>
              <tbody className="text-sm" data-id="element-196">
                {[['La prepaga sigue negando después de la SSSalud', 'No sabés qué más hacer', 'Amparo de Salud paso a paso'], ['Necesitás cobertura urgente por orden judicial', 'Dependés de que el abogado tenga tiempo', 'Protocolo Cautelar. Cobertura en 48hs'], ['Querés reclamar por todo lo que te hicieron pasar', 'Resignás el daño sufrido', 'Sistema de tasación de daño moral y punitivo'], ['El abogado te cobra una fortuna porque no entendés nada', 'Pagás de más por ignorar el proceso', 'Checklist de consulta + 10 preguntas que ahorran miles'], ['La empresa autorizó pero tardó 3 meses', 'No reclamás nada extra', 'Calculadora de resarcimiento lista para completar'], ['Querés citar jurisprudencia para presionar más', 'No sabés qué fallos existen', 'Los 5 fallos de la CSJN que toda demanda debe citar']].map((row, i) => <tr key={i} className="border-b border-emerald-900/40 last:border-0" data-id="element-197">
                    <td className="p-4 font-medium text-emerald-50" data-id="element-198">
                      {row[0]}
                    </td>
                    <td className="p-4 text-emerald-200/60 bg-rose-500/5 text-center" data-id="element-199">
                      {row[1]}
                    </td>
                    <td className="p-4 font-bold text-emerald-300 bg-emerald-500/5 text-center" data-id="element-200">
                      {row[2]}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          <div className="bg-emerald-950/60 border border-emerald-800/40 rounded-3xl p-8" data-id="element-201">
            <h3 className="text-xl font-bold mb-6 flex items-center gap-2 text-emerald-400" data-id="element-202">
              <CheckCircle2 className="w-6 h-6" data-id="element-203" /> LA BIBLIA INCLUYE:
            </h3>
            <div className="grid sm:grid-cols-2 gap-4" data-id="element-204">
              {['Guía completa del Amparo de Salud en Argentina', 'Protocolo de medida cautelar (cobertura en 48hs por orden judicial)', 'Sistema de tasación de daño moral y punitivo', 'Calculadora de resarcimiento estimado', 'Guía de selección de abogados (10 preguntas filtro)', 'Diccionario de términos judiciales en lenguaje simple', 'Los 5 fallos de la CSJN más importantes en salud', 'Modelos pro para documentación judicial', 'Checklist de preparación para la primera consulta legal'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-205">
                  <FileCheck className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" data-id="element-206" />
                  <span className="text-emerald-100/80 text-sm leading-relaxed" data-id="element-207">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* More Testimonials */}
      <section className="py-20 px-4 bg-emerald-950/30" data-id="element-208">
        <div className="max-w-5xl mx-auto" data-id="element-209">
          <h2 className="text-3xl font-black text-center mb-12 text-white" data-id="element-210">
            ❤️ MÁS PERSONAS QUE YA LO TIENEN
          </h2>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-211">
            <TestimonialCard initials="CR" name="Cecilia R." location="Mendoza" product="Kit Completo + Biblia del Amparo" quote="Galeno me había negado la prótesis 4 veces. Con el kit armé el expediente, denuncié en SSSalud y a los 5 días llamaron para autorizar. No llegué al amparo pero saber que lo tenía me dio fuerza para seguir." data-id="element-212" />
            <TestimonialCard initials="RM" name="Roberto M." location="Buenos Aires" product="Kit Reclamo Médico Urgente" quote="El Modelo 5A del Tomo 2 para cirugía demorada fue exactamente lo que necesitaba. Lo completé en 10 minutos y lo mandé. Al día siguiente me llamaron para darme fecha quirúrgica." data-id="element-213" />
            <TestimonialCard initials="SC" name="Sofía C." location="La Plata" product="Kit Completo" quote="Mi hijo tiene CUD y la obra social le cortó las sesiones de fonoaudiología. Con el Modelo 6B del Tomo 2 y la Ley 24.901 resolví en 48 horas lo que llevaba 3 semanas sin solución." data-id="element-214" />
            <TestimonialCard initials="PA" name="Pablo A." location="Neuquén" product="Kit Reclamo Médico Urgente" quote="Las 12 frases del Bono 3 cambiaron todo. Antes escribía desde la desesperación. Ahora escribo desde el conocimiento. La prepaga responde diferente cuando ve que sabés el sistema." data-id="element-215" />
          </div>
        </div>
      </section>

      {/* Guarantee */}
      <section className="py-16 px-4 bg-emerald-600 text-white" data-id="element-216">
        <div className="max-w-3xl mx-auto text-center" data-id="element-217">
          <Shield className="w-16 h-16 mx-auto mb-6 text-emerald-100" data-id="element-218" />
          <h2 className="text-3xl md:text-4xl font-black mb-6" data-id="element-219">
            GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>
          <p className="text-xl mb-8 text-emerald-50" data-id="element-220">
            Abrís los tomos. Usás los modelos en tu reclamo.
            <br data-id="element-221" />
            Si en 7 días no es lo que esperabas:
            <br data-id="element-222" />
            <strong className="text-white" data-id="element-223">devolución del 100%</strong>
            <br data-id="element-224" />
            sin formularios, sin drama.
          </p>
          <p className="text-sm text-emerald-100 font-medium" data-id="element-225">
            Tasa de devoluciones: menos del 1%.
          </p>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 px-4" data-id="element-226">
        <div className="max-w-3xl mx-auto" data-id="element-227">
          <h2 className="text-3xl font-black text-center mb-12 text-white" data-id="element-228">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
          <div className="space-y-6" data-id="element-229">
            {[{
            q: '¿Sirve para todos los tipos de cobertura?',
            a: 'Sí. El kit tiene modelos y estrategias específicos para prepagas (Ley 26.682), obras sociales (Leyes 23.660/23.661), PAMI y hospitales públicos o privados. También cubre casos de discapacidad (Ley 24.901) y situaciones oncológicas, pediátricas y de adultos mayores.'
          }, {
            q: '¿Necesito saber de leyes para usarlo?',
            a: 'No. Los modelos están listos para copiar y completar con tus datos. Cada sección tiene instrucciones en lenguaje simple. El kit está diseñado para que cualquier persona pueda usarlo sin conocimientos legales previos.'
          }, {
            q: '¿Cómo recibo el material?',
            a: 'Inmediatamente después del pago recibís un email con el link de descarga. Acceso en menos de 5 minutos. Funciona desde cualquier celular, computadora o tablet.'
          }, {
            q: '¿Qué lo diferencia de buscar en Google?',
            a: 'En Google encontrás información general y contradictoria. Este kit tiene modelos específicos probados para Argentina, con fundamento legal actualizado, adaptados a prepagas y obras sociales reales, con el sistema de escalada completo y con casos ejemplo resueltos. No es información. Es un sistema listo para ejecutar.'
          }, {
            q: '¿Tiene garantía real?',
            a: 'Sí. 7 días sin preguntas. Si abrís los tomos y no es lo que esperabas, devolvemos el 100% del dinero. Sin formularios. Sin esperas. Sin drama.'
          }].map((faq, i) => <div key={i} className="bg-emerald-950/40 p-6 rounded-2xl border border-emerald-800/40" data-id="element-230">
                <h3 className="font-bold text-lg text-white mb-3" data-id="element-231">{faq.q}</h3>
                <p className="text-emerald-100/75 leading-relaxed" data-id="element-232">{faq.a}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Cost of Inaction */}
      <section className="py-20 px-4 bg-emerald-950/50 border-y border-emerald-900/50" data-id="element-233">
        <div className="max-w-4xl mx-auto" data-id="element-234">
          <h2 className="text-3xl md:text-4xl font-black text-center mb-12 flex items-center justify-center gap-3 text-white" data-id="element-235">
            <Scale className="w-8 h-8 text-rose-400" data-id="element-236" />
            ¿CUÁNTO CUESTA NO TENERLO?
          </h2>

          <div className="grid md:grid-cols-2 gap-4 mb-12" data-id="element-237">
            {[['Días sin medicación por demora de la prepaga', 'Tu salud se deteriora mientras esperás'], ['Cirugía postergada sin saber cómo presionar', 'Semanas de angustia y riesgo médico'], ['Horas de llamadas al 0800 sin resultado', 'Tu tiempo y energía se agotan'], ['Reintegros impagos que prescribís', 'Dinero que perdiste para siempre'], ['Negativas que aceptás porque no sabés qué más hacer', 'Coberturas a las que tenés derecho y nunca reclamás'], ['El próximo mes con el mismo problema', 'El mismo ciclo, el año que viene']].map((item, i) => <div key={i} className="bg-emerald-950/60 p-4 rounded-xl border border-emerald-800/40 flex flex-col justify-center" data-id="element-238">
                <div className="text-emerald-200/50 text-sm mb-1 line-through" data-id="element-239">
                  {item[0]}
                </div>
                <div className="text-rose-400 font-bold" data-id="element-240">{item[1]}</div>
              </div>)}
          </div>

          <div className="text-center" data-id="element-241">
            <p className="text-2xl font-medium mb-4 text-emerald-100" data-id="element-242">
              El próximo contacto con la prepaga puede ser diferente.
            </p>
            <p className="text-3xl font-black text-emerald-400 italic" data-id="element-243">
              "Tu salud no puede esperar a que ellos quieran responder." 🏥
            </p>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-20 px-4 border-b-8 border-emerald-500" data-id="element-244">
        <div className="max-w-3xl mx-auto text-center" data-id="element-245">
          <div className="mb-8" data-id="element-246">
            <p className="text-rose-400 font-bold mb-2 uppercase tracking-wider text-sm flex items-center justify-center gap-2" data-id="element-247">
              <Clock className="w-4 h-4" data-id="element-248" /> EL PRECIO CIERRA EN:
            </p>
            <CountdownTimer data-id="element-249" />
          </div>

          <div className="space-y-6" data-id="element-250">
            <div className="bg-emerald-950/40 p-6 rounded-2xl border border-emerald-800/40" data-id="element-251">
              <h3 className="font-bold text-xl mb-2 text-white" data-id="element-252">
                📘 KIT RECLAMO MÉDICO URGENTE
              </h3>
              <p className="text-emerald-200/70 mb-4 text-sm" data-id="element-253">
                6 Tomos + 6 Bonos · Todos los casos
              </p>
              <div className="mb-4" data-id="element-254">
                <span className="text-emerald-400/50 line-through text-sm mr-2" data-id="element-255">
                  $51.000
                </span>
                <span className="text-2xl font-black text-white" data-id="element-256">
                  $19.990 ARS
                </span>
              </div>
              <a href="https://www.mododigital.shop/cart/45990214303942:1" target="_blank" rel="noopener noreferrer" className="w-full bg-emerald-900 hover:bg-emerald-800 text-white font-bold py-4 px-6 rounded-xl transition-colors flex items-center justify-center gap-2 border border-emerald-700/50" data-id="element-257">
                QUIERO MI KIT <ArrowRight className="w-5 h-5" data-id="element-258" />
              </a>
            </div>

            <div className="bg-emerald-500/10 p-6 rounded-2xl border-2 border-emerald-500 relative" data-id="element-259">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-emerald-500 text-emerald-950 px-3 py-1 rounded-full text-xs font-bold" data-id="element-260">
                RECOMENDADO
              </div>
              <h3 className="font-bold text-xl mb-2 text-white" data-id="element-261">
                🏆 KIT COMPLETO + BIBLIA DEL AMPARO
              </h3>
              <p className="text-emerald-200/70 mb-4 text-sm" data-id="element-262">
                6 Tomos + 6 Bonos + Manual Judicial
              </p>
              <div className="mb-4" data-id="element-263">
                <span className="text-emerald-400/50 line-through text-sm mr-2" data-id="element-264">
                  $69.000
                </span>
                <span className="text-2xl font-black text-emerald-400" data-id="element-265">
                  $27.990 ARS
                </span>
              </div>
              <a href="https://www.mododigital.shop/cart/45990216597702:1" target="_blank" rel="noopener noreferrer" className="w-full bg-emerald-500 hover:bg-emerald-400 text-emerald-950 font-bold py-4 px-6 rounded-xl transition-colors shadow-lg shadow-emerald-500/25 flex items-center justify-center gap-2" data-id="element-266">
                QUIERO EL KIT + BIBLIA DEL AMPARO{' '}
                <ArrowRight className="w-5 h-5" data-id="element-267" />
              </a>
            </div>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6 text-sm font-medium text-emerald-200/60 mt-12" data-id="element-268">
            <div className="flex items-center gap-2" data-id="element-269">
              <Lock className="w-4 h-4" data-id="element-270" /> Pago 100% seguro
            </div>
            <div className="flex items-center gap-2" data-id="element-271">
              <Clock className="w-4 h-4" data-id="element-272" /> Acceso en 5 minutos
            </div>
            <div className="flex items-center gap-2" data-id="element-273">
              <Shield className="w-4 h-4" data-id="element-274" /> Garantía 7 días
            </div>
            <div className="flex items-center gap-2" data-id="element-275">
              <CreditCard className="w-4 h-4" data-id="element-276" /> Mercado Pago | Tarjeta |
              Transferencia
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#050d0a] text-emerald-200/60 py-12 px-4 text-center text-sm border-t border-emerald-900/50" data-id="element-277">
        <div className="max-w-4xl mx-auto" data-id="element-278">
          <div className="flex items-center justify-center gap-2 text-white font-bold text-xl mb-4" data-id="element-279">
            <HeartPulse className="w-6 h-6 text-emerald-400" data-id="element-280" />
            RECLAMO MÉDICO URGENTE™
          </div>
          <p className="mb-6 max-w-md mx-auto" data-id="element-281">
            El sistema N°1 para reclamar coberturas médicas ante prepagas, obras
            sociales y PAMI en Argentina.
            <br data-id="element-282" />
            <br data-id="element-283" />
            Porque tu salud no debería depender de que ellos tengan ganas de
            responder.
          </p>
          <div className="flex flex-wrap justify-center gap-6 mb-8" data-id="element-284">
            <a href="#" className="hover:text-emerald-300 transition-colors" data-id="element-285">
              soporte@reclamomedico.com.ar
            </a>
            <a href="#" className="hover:text-emerald-300 transition-colors" data-id="element-286">
              @reclamomedico
            </a>
            <a href="#" className="hover:text-emerald-300 transition-colors" data-id="element-287">
              www.reclamomedico.com.ar
            </a>
          </div>
          <p className="text-emerald-200/40 mb-4" data-id="element-288">
            © Reclamo Médico Urgente™ 2024 — Todos los derechos reservados.
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
          <p className="italic text-emerald-200/50" data-id="element-289">
            "Tu cobertura existe. Solo necesitás saber cómo exigirla."
          </p>
        </div>
      </footer>

      <RecentPurchaseToast data-id="element-290" />
    </div>;
}